import { render, staticRenderFns } from "./H2H.vue?vue&type=template&id=4497d699&scoped=true&"
import script from "./H2H.vue?vue&type=script&lang=js&"
export * from "./H2H.vue?vue&type=script&lang=js&"
import style0 from "./H2H.vue?vue&type=style&index=0&id=4497d699&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497d699",
  null
  
)

export default component.exports